import type { AuthenticatedUser, AuthenticatedUserResponse } from '@travel-crm/types';

import { apiRequest } from './api-client';

export const currentUserQueryKey = ['auth', 'current-user'] as const;

export async function fetchCurrentUser(): Promise<AuthenticatedUser> {
  const response = await apiRequest<AuthenticatedUserResponse>('/api/v1/auth/me');
  return response.data;
}

export async function login(email: string, password: string): Promise<AuthenticatedUser> {
  const response = await apiRequest<AuthenticatedUserResponse>('/api/v1/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  return response.data;
}

export function logout(): Promise<void> {
  return apiRequest<void>('/api/v1/auth/logout', { method: 'POST' });
}
